import { HTTP } from '../../utils'

export const createOrUpdateCareerIdea = (data) => {
  var url = '/careerIdea/'
  if (data.uuid) {
    url += data.uuid
  }
  return HTTP().put(url, data).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const populateCareerIdeaDetail = (uuid) => {
  return HTTP().get('/careerIdea/' + uuid).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteCareerIdea = (uuid) => {
  return HTTP().delete('/careerIdea/' + uuid).then(res => {
    return res
  })
  .catch(e => {
    console.log(e)
  })
}

export const populateCareerIdeas = () => {
  return HTTP().get('/careerIdea/findForCoachee').then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const populateCareerIdeasForUser = (userId) => {
  return HTTP().get('/careerIdea/findForUser/' + userId).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const createOrUpdateConnection = (data) => {
  var url = '/connection/'
  if (data.uuid) {
    url += data.uuid
  }
  return HTTP().put(url, data).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const populateConnectionDetail = (uuid) => {
  return HTTP().get('/connection/' + uuid).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteConnection = (uuid) => {
  return HTTP().delete('/connection/' + uuid).then(res => {
    return res
  })
  .catch(e => {
    console.log(e)
  })
}

export const populateConnections = (careerIdeaId) => {
  return HTTP().get('/connection/fetch/' + careerIdeaId).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveConnectionNote = (data) => {
  var url = '/connection/' + data.connectionId + '/addNote'
  return HTTP().put(url, data).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveCareerIdeaAndConnection = (data) => {
  return HTTP().put('/careerIdea/createCareerIdeaAndConnection', data).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCareerIdeaAndConnection = (courseId, isMainQuest) => {
  return HTTP().get('/careerIdea/courseId/' + courseId + '?isMainQuest=' + isMainQuest).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCareerIdeaAndConnectionForUser = (courseId, userId, isMainQuest) => {
  return HTTP().get('/careerIdea/courseId/' + courseId + '/user/' + userId + '?isMainQuest=' + isMainQuest).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/quest/api.js